import { PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledStatusWrapper: SxProps = {
  backgroundColor: PrimaryColors.white,
  position: 'absolute',
  top: '0',
  left: '0',
};

export const styledStatusText: SxProps = {
  color: PrimaryColors.black,
};
